// File: components/academySectionsComponents/AcademyTestimonialsSection.jsx

import React from "react";
import "./AcademyTestimonialsSection.css";

import testimonialImage1 from "../../Assets/images/benedicta2.jpeg";
import testimonialImage2 from "../../Assets/images/trev.jpeg";
import testimonialImage3 from "../../Assets/images/rejoince.jpeg";

export default function AcademyTestimonialsSection() {

  const testimonials = [
    {
      image: testimonialImage1,
      quote:
        "Ample House’s programs were instrumental in developing my leadership skills and transforming how I guide teams with confidence and clarity.",
      name: "Benedicta.",
      role: "HR"
    },

    {
      image: testimonialImage2,
      quote:
        "The intensive retreats created a powerful shift in our leadership culture and improved collaboration across our organization.",
      name: "Trevayne",
      role: "CEO"
    },

    {
      image: testimonialImage3,
      quote:
        "Working with Ample House gave our professionals the structure, mentorship, and systems needed for long-term leadership growth.",
      name: "Rejoice",
      role: "Manager"
    }
  ];

  return (

    <section className="academy-testimonials-section">

      <div className="academy-testimonials-container">

        {/* Header */}
        <div className="academy-testimonials-header">

        

          <h2>
            Leaders Transformed Through
            Meaningful Learning Experiences
          </h2>

          <p>
            Hear from professionals and organizations
            impacted through immersive leadership
            development and systems-driven learning.
          </p>

        </div>

        {/* Testimonials Grid */}
        <div className="academy-testimonials-grid">

          {testimonials.map((item, index) => (

            <div
              className="academy-testimonial-card"
              key={index}
            >

              <div className="academy-testimonial-glow"></div>

              {/* Profile Image */}
              <div className="academy-testimonial-image-wrapper">

                <img
                  src={item.image}
                  alt={item.name}
                  className="academy-testimonial-image"
                />

              </div>

              {/* Content */}
              <div className="academy-testimonial-content">

                <div className="academy-testimonial-quote-icon">
                  “
                </div>

                <p className="academy-testimonial-quote">
                  {item.quote}
                </p>

                <div className="academy-testimonial-divider"></div>

                <div className="academy-testimonial-info">

                  <h4>
                    {item.name}
                  </h4>

                  <span>
                    {item.role}
                  </span>

                </div>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>

  );
}